import { LazyQueryExecFunction } from '@apollo/client/react';
import {
  AssetCategoriesSearchListQuery,
  AssetCategoriesSearchListQueryVariables,
  AssetCategory,
  AssetCategoryFilterInputObject,
  SortDirectionEnum,
} from 'graphql-common';
import { DEFAULT_SEARCH_LIST_VARIABLES } from '@lib/enums/urls';
import getLoadOptionsResult from '@lib/utils/getLoadOptionsResult';
import createSearchFilters, {
  defaultSearchListSchema,
} from '@lib/utils/createSearchFilters';
import QrCodePrefix from '@lib/enums/qrCodePrefix';
import { LoadOptionsParams } from '@lib/components/Select/types';

type FetchLazyQuery = LazyQueryExecFunction<
  AssetCategoriesSearchListQuery,
  AssetCategoriesSearchListQueryVariables
>;

export const fetchSearchList = async (
  searchQuery: string,
  fetchLazyQuery: FetchLazyQuery,
  page: number,
  additionalFilters?: object[],
) => {
  const options: { variables: AssetCategoriesSearchListQueryVariables } = {
    variables: {
      ...DEFAULT_SEARCH_LIST_VARIABLES,
      page,
      sorts: { name: SortDirectionEnum.Asc },
    },
  };
  const filters: AssetCategoryFilterInputObject[] = [];
  if (searchQuery) {
    filters.push(...createSearchFilters(searchQuery, defaultSearchListSchema));
  }
  if (additionalFilters?.length) {
    filters.push(...additionalFilters);
  }
  if (filters.length) {
    options.variables.filters = filters;
  }
  const { data } = await fetchLazyQuery(options);
  return getLoadOptionsResult(
    data,
    (dataItem: AssetCategory) => ({
      value: dataItem.id,
      label: dataItem.name,
      color: dataItem.color,
      data: {
        prefix: dataItem.prefix || QrCodePrefix.Asset,
      },
    }),
    searchQuery,
  );
};

export const getAssetCategoriesLoadOptions =
  (fetchLazyQuery: FetchLazyQuery, additionalFilters?: object[]) =>
  (searchQuery: string, loadedOptions: unknown, params: LoadOptionsParams) =>
    fetchSearchList(
      searchQuery,
      fetchLazyQuery,
      params?.page || 1,
      additionalFilters,
    );
